module.exports = __webpack_public_path__ + "static/img/yeswecan0017.6ecaf72.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0017.png
// module id = 592
// module chunks = 1